import { styled } from '@linaria/react';
import { layout, primitives, semantic, size, space } from '../../theme/tokens';

export const TopBar = styled.div<{ $borderless?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${space['space-300']} ${space['space-600']};
  border-bottom: ${({ $borderless }) =>
    $borderless ? 'none' : `${size.stroke['stroke-default']} solid ${semantic.border.default}`};
  background: ${semantic.bg.canvas};
  position: sticky;
  top: var(--announcement-banner-height, 0px);
  z-index: 50;
  min-height: ${primitives.size['size-1400']};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${space['space-300']} ${space['space-1000']};

    & > button {
      left: ${space['space-1000']};
    }
  }
`;
